/* The component responsible for rendering the actual modals */
import React from 'react';
import useModalV3 from 'Hooks/useModalV3';
import { Modal } from 'pounceV2';

export const ModalManagerV3: React.FC = () => {
  const { modalState, hideModal } = useModalV3() ?? {};
  const { modalContent, modalProps, open } = modalState ?? {};
  const { onClose = () => {}, ...restModalProps } = modalProps ?? {};

  const onModalClose = React.useCallback(() => {
    onClose();
    hideModal?.();
  }, [onClose, hideModal]);

  if (!modalContent) {
    return null;
  }

  return (
    <Modal onClose={onModalClose} isOpen={open} {...restModalProps}>
      {modalContent}
    </Modal>
  );
};
